module.exports = __webpack_public_path__ + "img/blaupunkt.121ef0e6.png";